import { AuthCapabilityGrid } from './AuthCapabilityGrid.jsx';

export function AuthBrandingColumn({ favicon, registerUrl, registrationCredits = 0 }) {
  const giftAmount = Number(registrationCredits) || 0;
  const showGift = giftAmount > 0;
  return (
    <div class="pp-auth-branding pp-auth-branding--enter">
      <a class="pp-auth-branding__logo" href="/" aria-label="ProParcel ana sayfa">
        <img src={favicon} alt="" width={36} height={36} decoding="async" />
        <span>PROPARCEL</span>
      </a>

      <div class="pp-auth-branding__panel">
        <div class="pp-auth-branding__hero">
          <h1 class="pp-auth-branding__title">
            <span>Arazi Yatırımının</span>
            <span class="pp-auth-branding__title-accent">Yeni Platformu</span>
          </h1>
          <p class="pp-auth-branding__sub">Araziyi keşfet, analiz et, böl, yatırım kararını ver.</p>
        </div>

        {showGift ? (
        <div class="pp-auth-gift" role="region" aria-label="Yeni üyelere başlangıç hediyesi">
          <div class="pp-auth-gift__icon" aria-hidden="true">
            <i class="fas fa-gift" />
          </div>
          <p class="pp-auth-gift__eyebrow">Yeni üyelere başlangıç hediyesi</p>
          <p class="pp-auth-gift__credit" aria-label={`${giftAmount} Kredi`}>
            <span class="pp-auth-gift__amount">{giftAmount}</span>
            <span class="pp-auth-gift__unit">Kredi</span>
          </p>
          <a class="pp-auth-gift__cta" href="/harita/">
            Başla
          </a>
          <p class="pp-auth-gift__foot">
            Ücretsiz <strong>ProSorgu</strong> deneyimi
          </p>
        </div>
        ) : null}

        <AuthCapabilityGrid />

        {registerUrl ? (
          <p class="pp-auth-branding__hint">
            <a href={registerUrl}>Ücretsiz hesap oluşturun</a>
          </p>
        ) : null}
      </div>
    </div>
  );
}
